export default __webpack_public_path__ + "static/media/head04_vi_sp.fe26931b.png";